import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import API from '../../common/services/api.config.json';
import { ApiService } from 'app/modules/common/services/api.service';
import { ExpensesPeriod } from '../entities/monthly-expenses-modal';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
  providedIn: 'root'
})
export class MonthlyExpensesService {

  public expensesList = new MatTableDataSource<any>();
  public isListLoading = false;
  public selectedDatePeriod: ExpensesPeriod;

  constructor(private apiService: ApiService,
              private sharedService: SharedService) { }

  public getInitialDates(): Observable<RestResponse> {
    const url = `${API.Gastos.getInitialDate}`;
    return this.apiService.get(url);
  }

  public getInitialExpenseData(period: ExpensesPeriod): Observable<RestResponse> {
    let url = `${API.Gastos.getExpensesList}`;
    url = url.replace('{year}', String(period.year));
    url = url.replace('{month}', String(period.month));
    return this.apiService.get(url);
  }

  public updateExpensesList(period: ExpensesPeriod): void {
    this.isListLoading = true;
    this.clearExpensesList();
    this.getInitialExpenseData(period).subscribe(res => {
      if (res.code === 0) {
        this.expensesList.data = res.result;
        this.selectedDatePeriod = period;
      } else {
        this.sharedService.ShowSnackBar('', 'okay', 2000);
      }
      this.isListLoading = false;
    }, error => {
      this.sharedService.ShowSnackBar('', 'okay', 2000);
      console.error(error);
      this.isListLoading = false;
    });
  }

  public clearExpensesList(): void {
    this.expensesList.data = [];
  }

  public updateExpenseRow(expenseRow: any): Observable<RestResponse> {
    let url = `${API.Gastos.updateExpenseRecord}`;
    url = url.replace('{id}', String(expenseRow.id));
    return this.apiService.put(url, expenseRow);
  }

  public loadNewMonth(): Observable<RestResponse> {
    let url = `${API.Gastos.loadNewMonth}`;
    url = url.replace('{year}', String(this.selectedDatePeriod.year));
    url = url.replace('{month}', String(this.selectedDatePeriod.month));
    return this.apiService.post(url);
  }

  public deshacerTraspasoRecord(expenseId: number): Observable<RestResponse> {
    let url = `${API.Gastos.deshacerTraspasoRecord}`;
    url = url.replace('{id}', String(expenseId));
    return this.apiService.put(url);
  }

  public transferExpenses(expenseRows: any[]): Observable<RestResponse> {
    const url = `${API.Gastos.traspasarExpenses}`;
    return this.apiService.put(url, expenseRows);
  }
  
  public repercutirExpenseRecord(expenseRow: any): Observable<RestResponse> {
    let url = `${API.Gastos.repercutirExpenseRecord}`;
    url = url.replace('{id}', String(expenseRow.id));
    return this.apiService.put(url, expenseRow);
  }

  public downloadCoordinadores(): Observable<RestResponse> {
    let url = `${API.Gastos.downloadCoordinadores}`;
    url = url.replace('{year}', String(this.selectedDatePeriod.year));
    url = url.replace('{month}', String(this.selectedDatePeriod.month));
    return this.apiService.post(url);
  }

}
